

//import 'react-devtools';
import { React, useEffect, useState, useRef } from 'react';
import { Alert, Button, Pressable, StyleSheet, Text, View } from 'react-native';
import { LayersControl, MapContainer, Marker, Popup, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import L from "leaflet";
//import "leaflet/dist/leaflet.css"; // breaks markers
import { Icon } from "leaflet";
//import Modal  from 'react-bootstrap/Modal';
//import Button from 'react-bootstrap/Button';
import useSWR from "swr";
import "./App.css";
import "leaflet-easybutton/src/easy-button.js"
import "leaflet-easybutton/src/easy-button.css";
//import "font-awesome/css/font-awesome.min.css";

// https://github.com/Leaflet/Leaflet.markercluster#all-options
import MarkerClusterGroup from "react-leaflet-markercluster";
import 'leaflet/dist/leaflet.css'
import 'react-leaflet-markercluster/styles'


// BUG in leaflet as trying to load distmarker-icon.ong 
// https://stackoverflow.com/a/51222271/2311479
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;
// /BUG

const apiURL = "https://map.netnix.ee:9000/devices";
//const apiURL = "https://" + window.location.hostname + ":9000/devices";
//
// command fetch to use cookies https://github.com/JakeChampion/fetch#sending-cookies
//const fetcher = (url) => fetch(url, { credentials: 'include' }).then( res => res.json() ).then( json => console.log('JSON: ', json) );
//const fetcher = (...args) => fetch(...args, { credentials: "same-origin" } ).then( res => res.json() );
const fetcher = (...args) => fetch(...args, { credentials: 'include' } ).then( (res) => res.json() );

const { BaseLayer } = LayersControl;


//////////// FUNCTIONS ///////////////////////////////////////


function ChangeView( center, zoom) {
	console.log('CENTER', center);
	const map = useMap();
	map.setView([59.5171700, 24.8494433], map.getZoom());
	return null;

}

function geoLockDevice( device ) {
	console.log(`Device ${device.name} geolocked.` );
	return true;
}

function immobilizeDevice( device ) {
	console.log(`Device ${device.name} immobilized.` );
	return true;
}



export default function App() {
	// Hooks
	const [ activeDevice, setActiveDevice ] = useState(null);
	const [ map, setMap ] = useState(null);
	const [ position, setPosition ] = useState(null);

	function lf() {
		if (!map) return;

		console.log('useEffect()');
		//if (map) alert('Yes map!');
		//if (!map) { alert("No map! Can't add buttons"); return; }
		//map._fadeAnimated = true;
		//map._zoomAnimation = true;
		//setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);

		console.log('Adding button');
		L.easyButton( 
			'<img style="width: 32px; padding: 0px;" src="/blank-profile.png"/>', 
			async function() {
			//const loginUrl = 'https://id.netnix.ee/auth/ee';
			//const loginUrl = 'https://id.netnix.ee/api/auth/webeid';
			//const loginUrl = 'https://id.netnix.ee/api/auth/webeid/challenge';
			const loginUrl = 'https://id.netnix.ee/';

			window.open(loginUrl);
			// try {
			// 	const response = await fetch(loginUrl, {
			// 		credentials: 'include',
			// 	});
			// 	if (!response.ok) {
			// 		throw new Error('Reponse from WebEid authentication: ${response.status}'); 
			// 	}
			// 	const result = await response.json();
			// 	console.log(result);
			// } catch (error) {
			// 	console.log(error.message); }
		}).setPosition('topright').addTo(map);
	}
	useEffect( lf, [map]);


	const { data, error, isLoading } = useSWR( apiURL, fetcher, { refreshInterval: 8000 } );
	//console.log('useSWR returns: ', data, error, isLoading);
	//const { devices } = useSWR( apiURL, fetcher);
	console.log('Data: ', data)
	const devices = data;
	console.log('DEVICES:', devices);
	//const data = devices;

	//if (error) {
	//	console.log("An error has occurred.");
		//devices = [];
	//}
	//if (isLoading) { 
	//	return <div>Loading devices</div>
	//}

	//var devices = data && !error ? data : [];
	//var devices = [ { "uuid": "dc8ac873-0854-40db-a122-ebd1dc2c50d4", "location": { "latitude": "59.5171700", "longitude": "24.8494433" } } ];
	//var devices = [];
	console.log('Devices: ',  devices);

	if ( devices && devices.length > 0 ) {
		var center = [ devices[0].location.latitude, devices[0].location.longitude ];
	} else {
		var center = [24.76, 59.43];
	}
	console.log('CENTER234324: ', center);
	const styleImg = { width: '40px', };
	//const imageUrl = 'http://172.16.21.90:3000/%s.jpg' + device.name + 'jpg';

	const styles = StyleSheet.create({
	  container: {
		flex: 1,
		justifyContent: 'center',
	  },
	  text: {
		fontSize: 16,
	  },
	  wrapperCustom: {
		borderRadius: 8,
		padding: 6,
	  },
	  logBox: {
		padding: 20,
		margin: 10,
		borderWidth: StyleSheet.hairlineWidth,
		borderColor: '#f0f0f0',
		backgroundColor: '#f9f9f9',
	  },
	});


	// https://react-leaflet.js.org/docs/example-events/
	function LocationMarker() {
		const [position, setPosition] = useState(null)
		const map = useMapEvents({
		click() {
		  map.locate()
		},
		locationfound(e) {
		  setPosition(e.latlng)
		  //map.flyTo(e.latlng, map.getZoom())
   		},
  	})

  	return position === null ? null : (
		<Marker position={position}>
		  <Popup>You are here</Popup>
		</Marker>
	  )
	}

	////////////// UI ELEMENTS /////////////////////////////////7


	// this.ChangeView = this.ChangeView.bind(this);

	function DeviceList( {devices} ) {
		const mapInstance = useMap()
		const listItems = devices.map( device => 
			<li key={device.uuid} >
				<Pressable 
					const center = { [ Number(device.location.latitude), Number(device.location.longitude) ] }
					onPress={ () => ChangeView() } 
				>
					<Text>{device.name}</Text>
				</Pressable>
			</li>
		);
		return <div id="deviceList"><ul>{listItems}</ul></div>;
	}
	//		<DeviceList style={{ zIndex: 1500 }} devices={devices} />

	function DeviceImage( {device} ) {
		return (
		<img 
			style={{width: '100px',}} 
			src={ `/${device.name}.jpg` }
		/>
		);
	}




	function LockButton( {device} ) {
		return ( <Pressable onPress={ () => geoLockDevice(device) } 
					style={({pressed}) => [{
						backgroundColor: pressed ? 'rgb(210, 230, 255)' : 'lightgreen', },
					styles.wrapperCustom ]}
		>
		{({pressed}) => (
			  <Text style={styles.text}>{pressed ? 'Pressed!' : 'Geo Lock'}</Text>
			)}
		</Pressable>
		)
	}

	function ImmobilizeButton({device}) {
		return ( <Button onPress={ () => immobilizeDevice(device) } >
					<Text style={{ }} >Immobilize</Text>
				</Button>
		)

	}

	function LoginEstonia( ) {
		const authEE = 'https://id.netnix.ee/auth/ee/';
		var { data, error, isLoading } = useSWR( authEE, fetcher);
	}


	function LoginDialog( ) {
		const [show, setShow] = useState(false);
		const handleLoginEstonia = () => LoginEstonia(); 
		const handleClose = () => setShow(false);
		const handleShow = () => setShow(true);

		return ( <div id='login' >
				<Popup>
					<Pressable
						style={{ zIndex: 1400 }} 
						onClick={ handleShow }>
					Login8</Pressable>
				</Popup>
			</div>
		);
	}
	//<LoginDialog style={{ zIndex: 120, height: "10vh", }} />
	


	function LoginButton( ) {
		const callBack = function() { LoginDialog(); } 
		return <div 
					className='leaflet-control-layers leaflet-top leaflet-right leaflet-control leaflet-bar' 
					style={{ right: 5, top: 60, zIndex: '1201' }} 
					>
					<Button style={{ zIndex: 1200 }}
					onClick={{ }}
					> </Button>
					<Pressable style={{ zIndex: '1201', justifyContent: center, backgroundColor: '#ffffff' }} onClick={ callBack } >
						<img style={{ width: 30, padding: 2,  }}  src="/blank-profile.png"/>
					</Pressable>
				</div>
	}

	function LoginButton2( ) {
		const callBack = function() { LoginDialog; } 
		return <div></div>
	}


	function GoogleMapsLink( { device } ) {
		const url = "https://www.google.com/maps/place/" ;
		const lat = device.location.latitude;
		const long = device.location.longitude;
		//"<a href=" + url + device.location.latitude + "," + device.location.longitude + ">" + device.location.latitude + ", " + device.location.longitude + "</a>"
		//
		//			<a href=<GoogleMapsLink device={ device } />  >kala </a> <br/>
		return ( url + lat + "," + long )
	}



	/////////// MAP /////////////////////////////////////////////
	return (
		<MapContainer center={ center } zoom={ 12  } style={{ zIndex: 10, height: "100vh"}} ref={ setMap }  >

			<LayersControl style={{ zIndex: 100}} collapsed={true}>
				<BaseLayer checked name="OpenStreetMap">
					<TileLayer
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
						attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>
						contributors' 
					/>
				</BaseLayer>
			</LayersControl>

			<ChangeView center={center} zoom={15} />


			<MarkerClusterGroup disableClusteringAtZoom={ 16 } singleMarkerMode={ false } color= { '#5281c9' }>
				{ devices && devices.map( device => (
					<Marker key={ device.uuid } position={ [device.location.latitude, device.location.longitude] } >
						<Popup>
							<h2>{ device.name }</h2>
							<DeviceImage device={ device } />
							<div>
							Location:  { device.location.latitude}, {device.location.longitude }<br/>
							Last seen: { device.lastseen }<br/> 
							Engine: not running<br/>
							Battery: {device.battlvl } %<br/>
							Ext battery: { device.battlvl } V<br/>
							<LockButton device={device} />
								<View style={styles.container}>
									<ImmobilizeButton device={device} />
								</View>
							</div>
						</Popup>
					</Marker>
				))}
			</MarkerClusterGroup>
		</MapContainer>
	);
}

// vim: sw=4 ts=4 noexpandtab
